import '../assets/styling/Contact.css';
import { FiArrowUpRight } from 'react-icons/fi';
import React, { useState } from 'react';
import { config } from '../config';

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(false);

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      phone: e.target.phone.value,
      message: `Subject: ${e.target.title.value}\n\nMessage: ${e.target.message.value}`,
      UUID: config.contactUuid
    };

    try {
      const response = await fetch(`${config.backendUrl}/email`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSuccess(true);
        e.target.reset();
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to send message');
      }
    } catch (error) {
      setError(error.message || 'Failed to send message, please try again.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-card">
      <div className="contact-info">
        <h2>Contact</h2>
        <hr className="contact-hr" />
        <p>Contactați-ne acum prin telefon sau prin e-mail și vă vom răspunde cât mai curând posibil.</p>
        <div className="contact-info-block">
          <strong>Adresă Birou</strong>
          <p>Bld. Dimitrie Cantemir nr 25 bl 2 sc C etaj 5 ap 20 bucuresti sector 4 cod postal 040237</p>
        </div>
        <div className="contact-info-block">
          <strong>Adresă E-Mail</strong>
          <p>info@vibe9.org</p>
        </div>
        <div className="contact-info-block">
          <strong>Telefon</strong>
          <p>+40 773 907 907</p>
        </div>
        <div className="contact-info-block">
          <strong>Program Birou</strong>
          <p>Luni - Vineri: 10.00 – 18.00</p>
        </div>
      </div>
      
      <div className="contact-form-side">
        <h3 style={{textAlign: 'center', marginBottom: '1rem'}}><br /><span style={{fontWeight: 'bold', fontSize: '1.5rem'}}>Consultanță</span></h3>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">Mesajul a fost trimis cu succes!</div>}
        <form onSubmit={sendEmail} className="contact-form">
          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Nume & Prenume *"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Adresă E-Mail*"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              id="phone"
              name="phone"
              placeholder="Număr de Telefon"
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              id="title"
              name="title"
              placeholder="Subiect"
              required
            />
          </div>
          <div className="form-group">
            <textarea
              id="message"
              name="message"
              placeholder="O scurta descriere"
              rows="6"
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? 'Se trimite...' : 'Trimite'}
            <FiArrowUpRight />
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact; 